import { AppState } from '../../interfaces/app/AppState';
import { SET_COLOR, SET_TEMPLATE } from './appActionTypes';
import { TemplatesList } from '../../enums/TemplatesList';

//TODO template panel for testing

const initialState: AppState = {
  template: TemplatesList.MODERN,
  themeColor: '#0AC2A2',
};

const navReducer = (state = initialState, action: { type: string; template: TemplatesList; color: string }): AppState => {
  switch (action.type) {
    case SET_TEMPLATE:
      return { ...state, template: action.template };
    case SET_COLOR:
      return { ...state, themeColor: action.color };
    default:
      return state;
  }
};

export default navReducer;
